module.exports = __webpack_public_path__ + "img/tag-pcb-firmware.4434bed1.svg";